module.exports = __webpack_public_path__ + "img/About-ban-mobile.c1eaba15.png";